/**
 * Einstieg Header-Suche (sitewide; eingebunden über mp-page-styles.php).
 */
import { initHeaderSearch } from '../components/header-search/header-search.js';

initHeaderSearch();
